import { connect } from 'react-redux'
import ServiceRestoreModal from '../../components/services/ServiceRestoreModal'
import { serviceRestore, actionCreators } from '../../state/actions/services'
import {
  getService,
  getServiceProcessing,
  getServiceProcessingError,
  getServiceRestoreServiceId
} from '../../state/reducers/services'
import { IStoreState } from '../../types'

const mapStateToProps = (state: IStoreState, ownProps: any) => {
  const serviceId = getServiceRestoreServiceId(state)
  return {
    service: serviceId ? getService(state, serviceId) : undefined,
    processing: getServiceProcessing(state),
    error: getServiceProcessingError(state)
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    onCancelClick: () => {
      dispatch(actionCreators.serviceRestoreModalHide())
    },
    onRestoreClick: (serviceId: string) => {
      dispatch(serviceRestore(serviceId))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceRestoreModal)



// WEBPACK FOOTER //
// ./src/containers/services/ServiceRestoreModal.ts